export const baseUrl = process.env.REACT_APP_BASE_URL;
export const apiKey = process.env.REACT_APP_ACCU_WEATHER_API_KEY;
export const delayTime = 500